/**
 * Source and transport are independent connector properties. Both must match
 * before a connector can use the registry WalletConnect execution path.
 */
export const isWalletConnectRegistryConnector = (connector) => connector?.source === 'registry'
    && connector.type === 'walletConnect';
